import { FormControl, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import Validator from 'validator';

@Directive({
    selector: '[floUrl]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: UrlDirective, multi: true },
    ],
})
export class UrlDirective {
    @Input() public allowMultiple: boolean = false;
    private formControl: FormControl;

    public validate(control: FormControl): { [s: string]: boolean } {
        this.formControl = control;

        if (control.value) {
            if (!Validator.isURL(control.value, { protocols: ['http', 'https'], require_protocol: true })) {
                return { invalidUrl: true };
            }
        }

        return null;
    }
}
